import { Box, Typography, useTheme } from '@mui/material';
import { FileUploader } from 'react-drag-drop-files';
import { MdOutlineFileUpload } from 'react-icons/md';

export default function UploadFile({ allowedFileTypes, selectedFiles, handleChange }: any) {
  const theme = useTheme();
  return (
    <Box position='relative'>
      <FileUploader
        multiple={true}
        handleChange={handleChange}
        name='file'
        types={allowedFileTypes ?? fileTypes}
        maxSize={50}
      >
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          border='1.5px dashed #ECECEC'
          borderRadius={2}
          padding='24px 16px'
          sx={{ cursor: 'pointer' }}
        >
          <MdOutlineFileUpload style={{ color: theme.palette.primary.main, fontSize: '24px' }} />
          <Typography marginTop={1}>Click to upload or drag and drop</Typography>
          <Box display='flex' alignItems='center' my={1}>
            <Typography color='secondary' textAlign='center' variant='body2' sx={{ wordBreak: 'break-word' }}>
              Only {allowedFileTypes?.join(', ')} files.
            </Typography>
          </Box>
        </Box>
      </FileUploader>
      <Typography fontSize={13} gutterBottom color='secondary'>
        {selectedFiles && `Number of files selected: ${selectedFiles?.length ?? '0'}`}
      </Typography>
    </Box>
  );
}

const fileTypes = [
  'pdf',
  'txt',
  'htm',
  'html',
  'doc',
  'docx',
  'xlsx',
  'pptx',
  'py',
  'js',
  'java',
  'c',
  'cpp',
  'h',
  'php',
  'go',
  'ts',
  'sh',
  'cs',
  'kt',
  'md',
  'markdown',
  'csv'
];
